export const STYLE_OPEN = {
  transform: 'translateX(0)',
  transition: 'transform 0.3s ease',
};

export const STYLE_CLOSE = {
  transform: 'translateX(-100%)',
  transition: 'transform 0.3s ease',
};
export const STYLE_SINGLE_PAGE_OPEN = {
  transform: 'translateX(0)',
  transition: 'transform 0.3s ease',
};

export const STYLE_SINGLE_PAGE_CLOSE = {
  transform: 'translateX(100%)',
  transition: 'transform 0.3s ease',
};
